import { IFieldLangMap } from '@pharmsnap/shared/types/base'

export const ANS_TYPE_LANG: IFieldLangMap = {
  ACADEMY: {
    cn: '院校/研究所',
    en: 'Academy',
    jp: '大学/研究機関',
  },
  COMPANY: {
    cn: '公司',
    en: 'Company',
    jp: '企業',
  },
  GOVERNMENT: {
    cn: '政府',
    en: 'Government',
    jp: '政府機関',
  },
  PERSON: {
    cn: '个人',
    en: 'Person',
    jp: '個人',
  },
  HOSPITAL: {
    cn: '医院',
    en: 'Hospital',
    jp: '病院',
  },
  BANK: {
    cn: '银行',
    en: 'Bank',
    jp: '銀行',
  },
  OTHER: {
    cn: '其他',
    en: 'Other',
    jp: 'その他',
  },
}
